import React from "react";
import { ClipboardList } from "lucide-react";
import { Step } from "@/pages/booking/bookingUi";

export const ServicePickerStep = ({ form, setForm, catChips, activeCat, setActiveCat, filteredServices }) => {
  const picked = form.services || [];
  const toggle = (id) =>
    setForm({
      ...form,
      services: picked.includes(id) ? picked.filter((x) => x !== id) : [...picked, id],
    });
  return (
    <Step n="02" title="Pick your services" Icon={ClipboardList}>
      <div className="flex items-center justify-between mb-3">
        <p className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">Select all that apply — book them in one visit</p>
        <span data-testid="booking-services-count" className={`font-mono text-[10px] uppercase tracking-widest px-2 py-0.5 border ${picked.length ? "border-brand-red/50 text-brand-red" : "border-zinc-800 text-zinc-500"}`}>
          {picked.length} selected
        </span>
      </div>
      {catChips.length > 1 && (
        <div data-testid="booking-cat-bar" className="flex items-center gap-2 flex-wrap mb-4">
          {catChips.map((chip) => {
            const isActive = activeCat === chip.id;
            return (
              <button
                key={chip.id}
                type="button"
                data-testid={`booking-cat-${chip.id}`}
                onClick={() => setActiveCat(chip.id)}
                className={`px-3 py-1.5 text-[10px] font-mono uppercase tracking-widest border transition-colors ${
                  isActive
                    ? "border-brand-red text-brand-red bg-brand-red/10"
                    : "border-zinc-800 text-zinc-400 hover:text-white hover:border-zinc-600"
                }`}
              >
                {chip.label}
              </button>
            );
          })}
        </div>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {filteredServices.map((s) => {
          const isOn = picked.includes(s.id);
          return (
            <label
              key={s.id}
              data-testid={`booking-service-${s.id}`}
              className={`cursor-pointer border p-4 transition-colors ${
                isOn ? "border-brand-red bg-red-500/10" : "border-zinc-800 hover:border-zinc-600"
              }`}
            >
              <input
                type="checkbox"
                name="services"
                className="hidden"
                value={s.id}
                checked={isOn}
                onChange={() => toggle(s.id)}
              />
              <div className="flex items-center justify-between gap-2">
                <span className="flex items-center gap-2 font-display uppercase text-base text-white tracking-tight">
                  <span className={`h-4 w-4 shrink-0 grid place-items-center border text-[10px] leading-none ${isOn ? "border-brand-red bg-brand-red text-white" : "border-zinc-700 text-transparent"}`}>✓</span>
                  {s.title}
                </span>
                <span className="font-mono text-xs text-brand-red">${s.price_from}</span>
              </div>
              <p className="mt-1 text-xs text-zinc-500 pl-6">{s.duration_min} min</p>
            </label>
          );
        })}
        {!filteredServices.length && (
          <div data-testid="booking-cat-empty" className="sm:col-span-2 border border-zinc-900 bg-zinc-950 p-6 text-center text-zinc-500 font-mono text-xs uppercase tracking-widest">
            No services in this category yet.
          </div>
        )}
      </div>
    </Step>
  );
};
